import {Component} from '@angular/core';
import {CrPolicyProduct} from './cr-policy-product';
import {ControlContainer, NgForm} from '@angular/forms';
import {PolicyContractVersionService} from '../../../../../bonding_shared/services';

@Component({
  selector: 'cr-single-risk-product',
  templateUrl: './cr-single-risk-product.component.pug',
  viewProviders: [{provide: ControlContainer, useExisting: NgForm}],
})
export class CrSingleRiskProductComponent extends CrPolicyProduct {
  constructor(policyContractVersionService: PolicyContractVersionService) {
    super(policyContractVersionService);
  }
}
